import request, { requestbody } from './request.js';

export async function page(params = {}) {
    return await request('/taxInspection/page', 'get', params);
}

export async function summary(params = {}) {
    return await request('/taxInspection/summary', 'get', params);
}

export async function detail(params = {}) {
    return await request('/taxInspection/detail', 'get', params);
}

export async function compare(params = []) {
    return await requestbody('/taxInspection/compare', 'post', params);
}

export async function updateDetail(params = []) {
    return await requestbody('/taxInspection/detail/update', 'post', params);
}
